import { Injectable } from '@angular/core';
import { ErrorHandlerService } from '../../utils/errors/error-handler.service';

@Injectable({
  providedIn: 'root'
})

export class NotificationService {

  constructor(private errorHandlerService:ErrorHandlerService) { }

  showNotification(error?: any, customMessage?: string, isSuccess: boolean = false) {
    this.errorHandlerService.handleNotification(error, customMessage, isSuccess);
  }
}
